import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import AnswerDragButton from '../ui/AnswerDragButton';

export default class AnswerDragObjects extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.txt = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.footer'), 18).setCenterAlign();
    this.add(this.txt);

    this.buttonContainer = this.scene.add.container();
    this.add(this.buttonContainer);
    this.buttons = [];

    const btn = new AnswerDragButton(this.scene, gameData.LT, this.buttonContainer);
    btn.on('dragstart', (pointer, dragX, dragY) => { this.handleStart(pointer, dragX, dragY, btn); });
    btn.on('drag', (pointer, dragX, dragY) => { this.handleButtonClick(pointer, dragX, dragY, btn); });
    btn.on('dragend', () => { this.handleButtonRelease(); });
    this.buttons.push(btn);
    let curX = btn.getBounds().width + 20;

    const btn1 = new AnswerDragButton(this.scene, gameData.EQ, this.buttonContainer);
    btn1.on('dragstart', (pointer, dragX, dragY) => { this.handleStart(pointer, dragX, dragY, btn1); });
    btn1.on('drag', (pointer, dragX, dragY) => { this.handleButtonClick(pointer, dragX, dragY, btn1); });
    btn1.on('dragend', () => { this.handleButtonRelease(); });
    btn1.x = curX;
    this.buttons.push(btn1);
    curX += btn1.getBounds().width + 20;

    const btn2 = new AnswerDragButton(this.scene, gameData.GT, this.buttonContainer);
    btn2.on('dragstart', (pointer, dragX, dragY) => { this.handleStart(pointer, dragX, dragY, btn2); });
    btn2.on('drag', (pointer, dragX, dragY) => { this.handleButtonClick(pointer, dragX, dragY, btn2); });
    btn2.on('dragend', () => { this.handleButtonRelease(); });
    btn2.x = curX;
    this.buttons.push(btn2);

    this.txt.y = this.buttonContainer.getBounds().height;
    this.buttonContainer.x = this.txt.width / 2 - this.buttonContainer.getBounds().width / 2;
    this.buttonContainer.alpha = 0;

    this.widthRef = this.txt.width;
  }

  handleStart(pointer, dragX, dragY, target) {
    this.hideButtons();

    const btn = target;
    const props = {
      answerType: btn.btnType,
      loc: { x: target.x, y: target.y }
    };
    this.emit('MAKE_DRAG_ITEM', props);
  }

  handleButtonClick(pointer, dragX, dragY, target) {
    const btn = target;
    const props = {
      answerType: btn.btnType,
      loc: { x: dragX, y: dragY }
    };
    this.emit('MAKE_DRAG_ITEM', props);
  };

  handleButtonRelease() {
    this.emit('RELEASE_DRAG_ITEM');
  };

  hideButtons() {
    this.scene.tweens.killTweensOf(this.buttonContainer);
    ABCyaPhaser.Tweens.addTween(this.buttonContainer, 300, { alpha: 0 }, Phaser.Math.Easing.Linear);
  };

  showButtons() {
    this.scene.tweens.killTweensOf(this.buttonContainer);
    ABCyaPhaser.Tweens.addTween(this.buttonContainer, 300, { alpha: 1 }, Phaser.Math.Easing.Linear);
  };
}